import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from 'src/components/atoms/button/button';
import Pagination from 'src/components/atoms/pagination/pagination';
import Spinner from 'src/components/atoms/spinner/spinner';
import Table from 'src/components/atoms/table/table';
import { useAppDispatch, useAppSelector } from 'src/reducers';
import { openModal } from 'src/reducers/modal.reducer';
import { commissionDefaultParams, getParamsFromUrl, setParamsToUrl } from 'src/utils/pagination-utils';
import { getCommissionsSearch } from '../../../reducers/commissions.reducer';
import { EDIT_COMMISSION_PERMISSION, isAuthorizedToHandleCapability } from '../../../utils/capability-utils';
import { Icon } from '../../atoms/icon';
import { CommissionCard } from './commissionCard';
import { CreateCommission } from './commissionModals/createCommission';
import styles from './commissions.module.scss';
import { CommissionsTableHeader } from './commissionsTableHeader';

const Commissions = () => {
  const dispatch = useAppDispatch();
  const { commissions, loadingSearch, failureSearch, successSearch, totalItems, refresh } = useAppSelector(state => state.commissions);
  const { user } = useAppSelector(state => state.authentication);
  const navigate = useNavigate();
  const location = useLocation();

  const [params, setParams] = useState(getParamsFromUrl(commissionDefaultParams, location));

  const createCommission = () => {
    dispatch(
      openModal({
        children: <CreateCommission />,
        opt: {
          size: 'sm',
          type: 'default',
          title: 'Crea commessa',
        },
      })
    );
  };

  const handlePagination = (page: number) => {
    setParams(prevState => ({
      ...prevState,
      currentPage: page + 1,
    }));
  };

  useEffect(() => {
    dispatch(getCommissionsSearch({ pagination: params }));
    setParamsToUrl(params, navigate);
  }, [dispatch, navigate, params, params.currentPage, params.sortBy, params.sortDirection, refresh]);

  if (loadingSearch) {
    return <Spinner className={styles.spinner} />;
  }

  return (
    <div className={styles.commissionsBody}>
      <div>
        {!loadingSearch && failureSearch && <div className="m-1">Errore nel caricamento delle commesse</div>}

        {!loadingSearch && successSearch && commissions.length === 0 && <div>Nessuna commessa trovata.</div>}
        {!loadingSearch && successSearch && user && commissions.length > 0 && (
          <>
            <Table>
              <Table.Header>
                <CommissionsTableHeader />
              </Table.Header>
              <Table.Body>
                {commissions.map(commission => (
                  <CommissionCard key={commission.id} commission={commission} />
                ))}
              </Table.Body>
            </Table>
            <Pagination
              activePage={params.currentPage - 1}
              itemsPerPage={params.postPerPage}
              totalItems={totalItems || 0}
              paginate={handlePagination}
            />
            {isAuthorizedToHandleCapability(user, EDIT_COMMISSION_PERMISSION) && (
              <Button className={styles.addButtonSticky} color="black" mode="solid" size="md" circle onClick={createCommission}>
                <Icon content="add" size="sm" color="white" />
              </Button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Commissions;
